import secrets from '../../secrets.json';

let apiUrl = secrets['apiUrl'];
let docUploadUrl = secrets['docUploadUrl'];
//apiUrl = "https://api-loanstatus-test.essent.us/";
//For debugging only apiUrl = "https://api-loanstatus-dev.essent.us/";

export async function GetLoanDetails(requestBody, options) {
    const { timeout = 8000 } = options;
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
    const response = await fetch(apiUrl + "api/DMZ/GetLoanDetail", {
        ...options,
        method: "POST",
        body: JSON.stringify(requestBody),
        signal: controller.signal,
        headers: {
            "Content-Type": "application/json"
        }
    });
    clearTimeout(id);
    return await response;
}

export async function GetMessages(requestBody, options) {
    const { timeout = 8000 } = options;
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
    const response = await fetch(apiUrl + "api/DMZ/GetCertStatusMessages", {
        ...options,
        method: "POST",
        body: JSON.stringify(requestBody),
        signal: controller.signal,
        headers: {
            "Content-Type": "application/json"
        }
    });
    clearTimeout(id);
    return await response;
}

export function UploadDocumentsUrl(certNum, lenderLoanNumber) {
    const qParams = `?UploadCertNum=${encodeURIComponent(btoa(certNum))}&lln=${encodeURIComponent(btoa(lenderLoanNumber))}`;
    return (docUploadUrl + qParams);
}